/**
 * 対象SKUファイルの拡張子に関する規則。
 *
 * 画面側の受理判定（`TargetSkuFileInput`）と S3 への PUT 時の Content-Type
 * （`PredictionErrorEvaluationForm`）で同じ導出を使う必要があるため、
 * コンポーネントから切り出している。
 */

/** ファイル名から小文字化した拡張子を取り出す。拡張子が無ければ空文字 */
export function targetSkuFileExtension(fileName: string): string {
  const parts = fileName.split('.');
  return parts.length > 1 ? (parts.pop() ?? '').toLowerCase() : '';
}

/**
 * S3 へ PUT するときの Content-Type。
 *
 * presigned URL は `.content_type()` 付きで署名されるため SigV4 の署名対象に
 * Content-Type が入る。PUT 時のヘッダが署名時の値と完全一致しないと S3 が 403 を返す。
 * ブラウザが付ける `File.type` は環境依存（Windows では `.csv` が
 * `application/vnd.ms-excel` になることがある）なので、ファイル名から導出して
 * バックエンドの `upload_content_type` と同じ値を送る。
 */
export function targetSkuUploadContentType(fileName: string): string {
  return targetSkuFileExtension(fileName) === 'txt' ? 'text/plain' : 'text/csv';
}
